export { StoreLocationMap } from './StoreLocationMap';
